// extracted by mini-css-extract-plugin
export var AuthorAvatarContainer = "bl_dl";
export var AuthorBioContainer = "bl_dj";
export var AuthorContainer = "bl_dh";
export var AuthorGradientBackground = "bl_dk";
export var AuthorInfoContainer = "bl_dm";
export var AuthorInfoDetails = "bl_dn";
export var AuthorInfoName = "bl_dp";
export var AuthorInfoSection = "bl_dq";
export var MuiPopperRoot = "bl_bK";
export var MuiTooltipPopper = "bl_bL";